import { afterNextRender, createComponent, EnvironmentInjector, Injector, Type } from '@angular/core';
import { Button } from '@openng/optimus-ui/button';
import { Message } from '@openng/optimus-ui/message';
import { Table } from '@openng/optimus-ui/table';

const COMPONENTS: Array<Type<unknown>> = [Button, Message, Table];

/**
 * Optimus lädt die Styles einer Komponente — und damit deren --p-*-Design-Token — erst bei der ersten Verwendung.
 * Die von Struts gerenderten Seiten nutzen diese Variablen in eigenem LESS, ohne die Angular-Komponenten je zu
 * mounten, deshalb werden sie hier einmalig instanziiert.
 *
 * - createComponent() ohne hostElement erzeugt ein Host-Element, das nie im Dokument hängt: die Komponenten sind
 *   zu keinem Zeitpunkt sichtbar.
 * - detectChanges() führt ngOnInit() aus; das Laden der Styles übernimmt damit die Library selbst.
 * - afterNextRender() läuft nach dem ersten Change-Detection-Zyklus, in dem provideOptimus() das Kundentheme
 *   anwendet, aber noch vor dem ersten Paint. Vorher wären die generierten Styles leer.
 * - Nach dem Laden können die Komponenten sofort zerstört werden; ngOnDestroy() räumt nur ihre eigenen Listener
 *   auf, nicht die injizierten <style>-Elemente.
 */
export const loadOptimusComponentStyles = (injector: Injector) => {
	const environmentInjector = injector.get(EnvironmentInjector);
	afterNextRender({
		write: () => COMPONENTS.forEach(component => {
			const componentRef = createComponent(component, { environmentInjector });
			componentRef.changeDetectorRef.detectChanges();
			componentRef.destroy();
		}),
	}, { injector });
};
